import { Controller } from "@hotwired/stimulus"
import Swiper from 'swiper'
import { Pagination, Navigation, Autoplay, EffectFade } from 'swiper/modules'

// Connects to data-controller="swiper"
//
// Supports the default 'slide' translate effect and 'fade' (re-added 2026-05).
// Other Swiper effects (cube, flip, cards, coverflow, creative) remain stripped —
// no template uses them.
export default class extends Controller {
  static values = {
    direction: String,
    autoplay: Number,
    speed: Number,
    effect: String,
  }

  connect() {
    const effect = (this.effectValue || "slide").toLowerCase()
    const modules = [Pagination, Navigation, Autoplay]
    if (effect === "fade") modules.push(EffectFade)

    const config = {
      loop: false,
      speed: this.speedValue || 3000,
      touchReleaseOnEdges: true,
      passiveListeners: true,
      modules,
      autoHeight: false,
      slidesPerView: "auto",
      lazy: true,
      navigation: false,
      direction: this.directionValue || 'horizontal',
      autoplay: {
        delay: this.autoplayValue || 3000,
        disableOnInteraction: true,
      },
      pagination: {
        el: ".swiper-pagination",
        clickable: true
      },
      grabCursor: true,
      centeredSlides: true,
    }

    if (effect === "fade") {
      config.effect = "fade"
      config.fadeEffect = { crossFade: true }
    }

    const swiper = new Swiper(this.element, config)

    if (swiper.slides.length <= 1) {
      swiper.allowTouchMove = false
    }
  }
}
